import { get } from 'lodash';
import {
  USERNAME,
  TOGGLE_DRAWER,
  USER_ROLE,
  USER_ROLE_TYPE,
  IS_LOGGED_IN,
  SET_DEPARTMENT_ID,
  SET_SYSTEM_DATE,
  SET_LOCATIONS,
  SET_BREAK_TYPES,
  SET_CHECK_IN_DATE_TIME,
  SET_CHECK_OUT_DATE_TIME,
  SET_IS_ON_BREAK,
  TOGGLE_SUCCESS_MODAL,
  SET_USER_LIST,
  TOGGLE_PROCESSING_MODAL,
  LOADING_DATE_FIRST_TIME,
  SET_DEPARTMENT_LIST,
  SET_LEAVE_CATEGORY_LIST,
  SET_PUNCH_ACTIONS,
  SET_ROLE_LIST,
  SET_USER_ROLE_LIST,
  CLEAR_STORE,
  SET_IS_CHECKED_IN,
  SET_CHECK_IN_LOCATION_ID,
  SET_CHECK_IN_DEPARTMENT_ID,
  SET_STATUS_LIST,
  SET_ALL_DEPARTMENT_LIST,
  SET_BREAK_ID,
  SET_PUNCH_ID,
  SET_SHIFT_TIME_MASTER,
  SET_NOTIFICATION_LIST,
  SET_WEB_SOCKET_STATUS,
  USER_PROFILE,
  SET_CHAT_MESSAGE_LIST,
  SET_CHAT_SELECTED_STAFF_ID,
  SET_CHAT_MESSAGE_QUEUE,
  SET_UNREAD_MESSAGE_INDICATOR,
  PROFILE_PIC,
  MENU_LIST,
  USER_MENU_LIST,
  CLIENT_ID,
  CURRENT_PLAN,
  TRAIL_PERIOD,
  SUBSCRIPTION_ID,
  SUBSCRIPTION_STATUS,
  BAND_LIST,
  AI_CHAT_HISTORY,
  CURRENT_AI_MESSAGE_DETAILS,
  FORM_NAME,
  LEAVE_LIST
} from '../actionsTypes';

const initialState = {
  userInfo: {
    name: '',
    roleId: 0,
    userRoleType: '',
    location_name: '',
    joining_date: '',
    username: '',
    email_id: '',
    job_title: '',
    department: '',
    payroll: '',
    employer_id: '',
    staff_department_id: '',
    threadid: '',
    role_id: []
  },
  webSocketStatus: 0,
  roleName: '',
  toggleDrawer: false,
  isLoggedIn: false,
  selectedDepartmentId: [],
  date: '',
  checkInDateTime: '',
  checkOutDateTime: '',
  isCheckedIn: false,
  checkInLocationId: '',
  checkInDepartmentId: '',
  isOnBreak: false,
  breakId: '',
  punchId: '',
  displaySuccessModal: false,
  successModalMessage: '',
  displayProcessingModal: false,
  loadingDataFirstTime: true,
  departmentList: [],
  allDepartmentList: [],
  locationList: [],
  breakTypeList: [],
  userList: [],
  leaveCategoryList: [],
  punchActions: [],
  roleList: [],
  userRoleList: [],
  shiftTimeMaster: [],
  holidayList: [],
  notificationList: [],
  statusList: [],
  chatMessageList: [],
  chatSelectedStaffId: '',
  chatMessageQueue: [],
  newMessageIndicatorList: [],
  profilePic: '',
  menuList: [],
  bandList: [],
  userMenuList: [],
  clientid: '',
  trailperiod: '',
  currentplan: '',
  aiChatHistory: [],
  currentAIMessageDetails: {},
  formName: '',
  Sucessicon: '',
  leaveList: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case USERNAME:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          name: action.payload
        },
      };
    case USER_ROLE:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          roleId: action.payload
        },
      }
    case USER_ROLE_TYPE:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          userRoleType: action.payload
        },
      }
    case USER_PROFILE:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          location_name: get(action.payload, 'location_name', ''),
          joining_date: get(action.payload, 'joiningdate', ''),
          username: get(action.payload, 'name', ''),
          email_id: get(action.payload, 'email_id', ''),
          job_title: get(action.payload, 'job_title', ''),
          department: get(action.payload, 'department', ''),
          payroll: get(action.payload, 'payroll', ''),
          employer_id: get(action.payload, 'userid', ''),
          staff_department_id: get(action.payload, 'staff_department_id', ''),
          userid: get(action.payload, 'userid', ''),
          threadid: get(action.payload, 'threadid', ''),
          role_id: get(action.payload, 'role_id', '')
        }
      }
    case TOGGLE_DRAWER:
      return {
        ...state,
        toggleDrawer: action.payload,
      };
    case IS_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: action.payload,
      };
    case SET_DEPARTMENT_ID:
      return {
        ...state,
        selectedDepartmentId: action.payload,
      }
    case SET_SYSTEM_DATE:
      return {
        ...state,
        date: action.payload,
      }
    case SET_LOCATIONS:
      return {
        ...state,
        locationList: action.payload,
      }
    case SET_BREAK_TYPES:
      return {
        ...state,
        breakTypeList: action.payload,
      }
    case SET_CHECK_IN_DATE_TIME:
      return {
        ...state,
        checkInDateTime: action.payload,
      }
    case SET_CHECK_OUT_DATE_TIME:
      return {
        ...state,
        checkOutDateTime: action.payload,
      }
    case SET_IS_ON_BREAK:
      return {
        ...state,
        isOnBreak: action.payload,
      }
    case TOGGLE_SUCCESS_MODAL:
      return {
        ...state,
        displaySuccessModal: action.payload.visibility,
        successModalMessage: action.payload.message,
        Sucessicon: action.payload.Sucessicon
      }
    case SET_USER_LIST:
      return {
        ...state,
        userList: action.payload
      }
    case TOGGLE_PROCESSING_MODAL:
      return {
        ...state,
        displayProcessingModal: action.payload
      }
    case LOADING_DATE_FIRST_TIME:
      return {
        ...state,
        loadingDataFirstTime: action.payload
      }
    case SET_DEPARTMENT_LIST:
      return {
        ...state,
        departmentList: action.payload
      }
    case SET_LEAVE_CATEGORY_LIST:
      return {
        ...state,
        leaveCategoryList: action.payload
      }
    case SET_PUNCH_ACTIONS:
      return {
        ...state,
        punchActions: action.payload
      }
    case SET_ROLE_LIST:
      return {
        ...state,
        roleList: action.payload
      }
    case SET_USER_ROLE_LIST:
      return {
        ...state,
        userRoleList: action.payload
      }
    case SET_IS_CHECKED_IN:
      return {
        ...state,
        isCheckedIn: action.payload
      }
    case SET_CHECK_IN_LOCATION_ID:
      return {
        ...state,
        checkInLocationId: action.payload
      }
    case SET_CHECK_IN_DEPARTMENT_ID:
      return {
        ...state,
        checkInDepartmentId: action.payload
      }
    case SET_STATUS_LIST:
      return {
        ...state,
        statusList: action.payload
      }
    case SET_ALL_DEPARTMENT_LIST:
      return {
        ...state,
        allDepartmentList: action.payload
      }
    case SET_PUNCH_ID:
      return {
        ...state,
        punchId: action.payload
      }
    case SET_BREAK_ID:
      return {
        ...state,
        breakId: action.payload
      }
    case SET_SHIFT_TIME_MASTER:
      return {
        ...state,
        shiftTimeMaster: action.payload
      }
    case SET_NOTIFICATION_LIST:
      return {
        ...state,
        notificationList: action.payload
      }
    case SET_WEB_SOCKET_STATUS:
      return {
        ...state,
        webSocketStatus: action.payload
      }
    case SET_CHAT_MESSAGE_LIST:
      return {
        ...state,
        chatMessageList: action.payload
      }
    case SET_CHAT_SELECTED_STAFF_ID:
      return {
        ...state,
        chatSelectedStaffId: action.payload
      }
    case SET_CHAT_MESSAGE_QUEUE:
      return {
        ...state,
        chatMessageQueue: action.payload
      }
    case SET_UNREAD_MESSAGE_INDICATOR:
      return {
        ...state,
        newMessageIndicatorList: action.payload
      }
    case SUBSCRIPTION_ID:
      return {
        ...state,
        subscriptionId: action.payload
      }
    case SUBSCRIPTION_STATUS:
      return {
        ...state,
        subscriptionStatus: action.payload
      }
    case PROFILE_PIC:
      return {
        ...state,
        profilePic: action.payload
      }
    case MENU_LIST:
      return {
        ...state,
        menuList: action.payload
      }
    case BAND_LIST:
      return {
        ...state,
        bandList: action.payload
      }
    case USER_MENU_LIST:
      return {
        ...state,
        userMenuList: action.payload
      }
    case CLIENT_ID:
      return {
        ...state,
        clientid: action.payload
      }
    case CURRENT_PLAN:
      return {
        ...state,
        currentplan: action.payload
      }
    case TRAIL_PERIOD:
      return {
        ...state,
        trailperiod: action.payload
      }
    case CLEAR_STORE:
      return {
        ...initialState
      }
    case AI_CHAT_HISTORY:
      return {
        ...state,
        aiChatHistory: action.payload
      }

    case CURRENT_AI_MESSAGE_DETAILS:
      return {
        ...state,
        currentAIMessageDetails: action.payload
      }
    case FORM_NAME:
      return {
        ...state,
        formName: action.payload
      }
      case LEAVE_LIST:
        return {
          ...state,
          leaveList: action.payload
        }
    default:
      return state;
  }
}
